<template>
  <!-- 根容器：控制显示隐藏 -->
  <div
    v-if="data.isNeed"
    class="modal-overlay-container"
    role="dialog"
    aria-modal="true"
  >
    <!-- 背景遮罩 (Overlay) -->
    <div
      class="modal-backdrop"
      @click="onCancel"
    ></div>

    <!-- 弹窗主体 (Modal) -->
    <!-- 对应: relative bg-white rounded-3xl p-6 w-full max-w-sm shadow-2xl animate-in... -->
    <div class="modal-card" @click.stop>
      
      <!-- 关闭按钮 (Close Button) -->
      <button
        type="button"
        @click="onCancel"
        class="close-btn"
        aria-label="Close"
      >
        <!-- X icon (SVG 保持不变) -->
        <svg viewBox="0 0 24 24" class="icon-svg" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 6L6 18" stroke-linecap="round" />
          <path d="M6 6l12 12" stroke-linecap="round" />
        </svg>
      </button>

      <!-- 标题 -->
      <!-- <h2 class="modal-title">尚未关注{{ GetSysTitle() }}</h2> -->
    <h2 class="modal-title">提交失败</h2>
      <!-- 蓝色提示框 -->
      <!-- 对应: bg-blue-50 border border-blue-100 rounded-2xl p-3 mb-4 -->
      <div class="hint-box">
        <div class="hint-content">
          <!-- AlertCircle icon (SVG 保持不变) -->
          <svg
            viewBox="0 0 24 24"
            class="alert-icon"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 8v5" stroke-linecap="round" />
            <path d="M12 16h.01" stroke-linecap="round" />
          </svg>

          <div class="hint-text-wrapper">
            <p class="hint-title">未关注公众号</p>
            <p class="hint-desc">
              <!-- 为了能够更好的为您服务，请先关注 <b>{{ data.wxName }}</b>！ -->
              用户无法获取行程通知
            </p>
          </div>
        </div>
      </div>

      <!-- 二维码区域 -->
      <div class="qr-section">
        <div class="qr-container">
          <div class="qr-wrapper">
            <!-- 绑定旧逻辑的图片地址 -->
            <img :src="data.url" class="qr-img" alt="微信公众号二维码" />
          </div>
        </div>
        <p class="qr-tip">扫码关注公众号后再次尝试</p>
      </div>

      <!-- 底部按钮 -->
      <!-- 对应: w-full bg-[#0057FF] text-white rounded-2xl... -->
      <button
        type="button"
        @click="onConfirm"
        class="confirm-btn"
        :disabled="loading"
      >
        {{ loading ? '处理中...' : '我知道了' }}
      </button>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { GetSysTitle, getUrlKey } from '@/utils/base'
import { GetSelfUrl } from '@/utils/request'
import router from '@/router'

export default {
  name: 'CheckUserFollowWx',
  props: {
    value: Boolean, // v-model 控制
  },
  data() {
    return {
      loading: false,
      data: {
        isNeed: false, // 控制弹窗显示的核心字段
        url: '',
        type: 'DIVEBOSS',
        wxName: '',
        wxBiz: '',
        isIOS: false
      }
    }
  },
  watch: {
    // 监听外部传入的 v-model，为 true 时触发检查
    value(newValue) {
      if (newValue) {
        this.$emit('input', false) // 立即重置父组件状态，由内部 isNeed 接管
        this.init()
      }
    }
  },
  created() {
    // 保留旧逻辑：判断 iOS 环境
    var u = navigator.userAgent
    this.data.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) 
  },
  methods: {
    GetSysTitle,
    
    // --- 核心初始化逻辑 (完全保留) ---
    init() {
      if (this.loading) return
      this.loading = true
      
      request({
        url: '/user/checkUserFollowWx',
        method: 'post'
      }).then(response => {
        this.loading = false
        if (!response.success) return

        this.data = response.data
        // 图片兜底逻辑
        if (!this.data.url) {
          if (this.data.type === 'DIVEBOSS') {
            this.data.url = '/img/divebossWx.jpg'
          } else {
            this.data.url = '/img/emptyWx.jpg'
          }
        }
        // 如果不需要关注，直接通知父组件完成
        //this.data.isNeed = true   //<<测试用代码
        if (!this.data.isNeed) {
          this.$emit('finish')
        }
      }).catch(() => {
        this.loading = false
      })
    },

    // --- 确认按钮逻辑 (完全保留) ---
    onConfirm() {
      if (this.loading) return
      this.loading = true
      
      const base32 = require('base32')
      var system = getUrlKey('system')
      var Backrouter = router.history.current.fullPath
      var url = GetSelfUrl() + 'loginCallbackThirdInfo?system=' + system + '&url=' + base32.encode(Backrouter)
      
      request({
        url: '/user/reCheckUserFollowWx',
        method: 'post',
        data: { url: url }
      }).then(response => {
        this.loading = false
        if (!response.success) return
        
        // 跳转微信授权或回调
        window.location.href = response.data
        this.data.isNeed = false
      }).catch(() => {
        this.loading = false
      })
    },

    // --- 取消/关闭逻辑 (完全保留) ---
    onCancel() {
      this.data.isNeed = false
      // 回退逻辑
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/store/index')
      }
      this.$emit('finish') // 也可以视作结束
    }
  }
}
</script>

<style scoped>
/* 
  CSS 重构说明：
  严格按照 Tailwind 类名进行 1:1 翻译，确保视觉一致。
*/

/* 根容器：fixed inset-0 z-50 flex items-center justify-center p-4 */
.modal-overlay-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem; /* p-4 */
}

/* 背景遮罩：absolute inset-0 bg-black/50 backdrop-blur-sm */
.modal-backdrop {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5); /* bg-black/50 */
  backdrop-filter: blur(4px); /* backdrop-blur-sm */
  -webkit-backdrop-filter: blur(4px);
}

/* 弹窗卡片：relative bg-white rounded-3xl p-6 w-full max-w-sm shadow-2xl animate-in... */
.modal-card {
  position: relative;
  background-color: #ffffff;
  border-radius: 1.5rem; /* rounded-3xl */
  padding: 1.5rem; /* p-6 */
  width: 100%;
  max-width: 24rem; /* max-w-sm */
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); /* shadow-2xl */
  animation: modalIn 0.2s ease-out forwards;
}

@keyframes modalIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

/* 关闭按钮：absolute right-4 top-4 text-gray-400 hover:text-gray-600 */
.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  color: #9CA3AF; /* text-gray-400 */
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
}
.close-btn:hover { color: #4B5563; }

.icon-svg { width: 1.25rem; height: 1.25rem; }

/* 标题：text-lg font-bold text-gray-900 text-center mb-4 */
.modal-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: #111827;
  text-align: center;
  margin: 0 0 1rem 0;
}

/* 蓝色提示框：bg-blue-50 border border-blue-100 rounded-2xl p-3 mb-4 */
.hint-box {
  background-color: #EFF6FF; /* bg-blue-50 */
  border: 1px solid #DBEAFE; /* border-blue-100 */
  border-radius: 1rem; /* rounded-2xl */
  padding: 0.75rem; /* p-3 */
  margin-bottom: 1rem; /* mb-4 */
}

/* flex items-start gap-2.5 */
.hint-content {
  display: flex;
  align-items: flex-start;
  gap: 0.625rem; /* gap-2.5 */
}

/* 图标：text-[#0057FF] flex-shrink-0 mt-0.5 */
.alert-icon {
  width: 1rem;
  height: 1rem;
  color: #0057FF;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.hint-text-wrapper { flex: 1; }

/* 提示标题：text-xs font-medium text-gray-900 mb-0.5 */
.hint-title {
  font-size: 0.75rem;
  font-weight: 500;
  color: #111827;
  margin: 0 0 0.125rem 0;
}

/* 提示内容：text-xs text-gray-600 leading-relaxed */
.hint-desc {
  font-size: 0.75rem;
  color: #4B5563;
  line-height: 1.625;
  margin: 0;
}
.hint-desc b { font-weight: 700; color: #1F2937; }

/* 二维码区域容器：mb-5 */
.qr-section { margin-bottom: 1.25rem; }

/* 灰色背景框：bg-gray-50 rounded-2xl p-3 border border-gray-100 */
.qr-wrapper {
  background-color: #F9FAFB;
  border-radius: 1rem;
  padding: 0.75rem;
  border: 1px solid #F3F4F6;
  display: inline-block;
}

.qr-container { display: flex; justify-content: center; }

/* 二维码图片：w-40 h-40 */
.qr-img {
  width: 10rem;
  height: 10rem;
  object-fit: contain;
  display: block;
}

/* 底部文字：text-xs text-gray-500 text-center mt-2 */
.qr-tip {
  font-size: 0.75rem;
  color: #6B7280;
  text-align: center;
  margin: 0.5rem 0 0 0;
}

/* 主按钮：w-full bg-[#0057FF] text-white rounded-2xl py-3 font-medium... */
.confirm-btn {
  width: 100%;
  background-color: #0057FF;
  color: #ffffff;
  border-radius: 1rem; /* rounded-2xl */
  padding: 0.75rem 0; /* py-3 */
  font-size: 1rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.confirm-btn:hover { background-color: #0046CC; }
.confirm-btn:active { transform: scale(0.98); }
.confirm-btn:disabled { opacity: 0.7; cursor: not-allowed; }

</style>